import { makeStyles } from '@material-ui/core';

import DataRow from './DataRow';
import { useRows } from './RenderContext';

const useStyles = makeStyles({
    root: {
        overflow: 'hidden',
    },
});

/**
 * This scroller implementation is used in print-mode. Instead of using infinite-scrolling,
 * we want to display everything inline so the browser can calculate page-breaks appropriately.
 *
 * @param {Object} props
 */
export default function StaticRenderer() {
    const classes = useStyles();
    const rows = useRows();

    return (
        <div className={classes.root}>
            {rows.map(({ id, row, deleted }, index) => (
                <DataRow key={id} row={row} deleted={deleted} index={index} />
            ))}
        </div>
    );
}
